// extracted by mini-css-extract-plugin
export default {"rodape":"rodape_rodape__sP6QS","rodape__icones":"rodape_rodape__icones__hVtaE"};